import { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalBody,
} from "reactstrap";
import { Dashboard, DashboardPage } from "../../utils/Constant";
import { Btn, H1, H2, H6, Image, P } from "../../AbstractElements";
import { useSweetAlert } from "../../Context/SweetAlertContext";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useNavigate } from "react-router-dom";
import Wallet from "./Wallet/Wallet";
import ProfileGreet from "./ProfileGreet/ProfileGreet";
import AccountOverview from "./AccountOverview/AccountOverview";
import TaskSummary from "./TaskSummary/TaskSummary";
import IncomeBoxes from "./incomes/IncomeBox";
import { useDashboardService } from "../../Service/Dashboard/DashboardService";
import { useCommonService } from "../../Service/CommonService/Commonservice";
import { decryptData } from "../../utils/helper/Crypto";
import DashboardSkeleton from "../Skeleton/DashboardSkeleton";
import Notifications from "./Notifications/Notifications";
import AchieversList from "./TopAchivers/AchieversList";

interface ActOverview {
  FinalPayout: number;
  FinalBalance: number;
}
interface walletI {
  BalanceInWallet: number;
  TotalWithdrawal: number;
}
const ContainerDashboard = () => {
  const [nloading, setnloading] = useState(true);

  const { fetchDashboardData } = useDashboardService();
  const { ApiCalling } = useCommonService();
  const [profileName, setprofileName] = useState<any>({});
  const [modalOpen, setModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [nextModalOpen, setnextModalOpen] = useState(false);
  const [showNextModal, setShowNextModal] = useState(false);
  const [fxstModal, setfxstModal] = useState(false);
  const [allData, setallData] = useState<any>([]);

  //const [actOverview, setactOverview] = useState<any[]>([]);
  const [tokenData, settokenData] = useState<any>([]);
  const [latestAnnouncement, setlatestAnnouncement] = useState<any>([]);
  const [popImageURL, setpopImageURL] = useState<any>("");
  const [LastLogin, setLastLogin] = useState<string>("");
  const [dashboardBox, setDashboardBox] = useState<any>([]);
  const { showAlert } = useSweetAlert();
  const navigate = useNavigate();
  const refdash = useRef(false);

  // set default state
  const [actOverview, setactOverview] = useState<ActOverview>({
    FinalPayout: 0,
    FinalBalance: 0,
  });

  const [myWallets, setmyWallets] = useState<walletI>({
    BalanceInWallet: 0,
    TotalWithdrawal: 0,
  });

  const [showDummyModal, setShowDummyModal] = useState<boolean>(false);

  useEffect(() => {
    setShowDummyModal(true); // always open when Dashboard mounts
  }, []);

  const closeModal = () => {
    document.body.style.paddingRight = "";
    setModalOpen(false);
    setnextModalOpen(true);
    setShowNextModal(true);
  };

  // handling Next Modal
  const closeNextModal = () => {
    document.body.style.paddingRight = "";
    setnextModalOpen(false);
    setfxstModal(true);
  };
  const closeFXSTModal = () => {
    document.body.style.paddingRight = "";
    setfxstModal(false);
  };

  const checkBlockUser = async () => {
  try {
    const param = {
      MemberId: decryptData(localStorage.getItem("clientId") as string),
      ActionMode: "CheckBlockUser",
    };

    const obj = {
      procName: "Client", // 👈 same as your jQuery code
      Para: JSON.stringify(param),
    };

    const res = await ApiCalling(obj);

    if (res[0]?.StatusCode === "0") {
      showAlert(res[0].Msg);
      localStorage.clear();
      navigate(`${import.meta.env.BASE_URL}/login`);
      return false;
    }
    return true;
  } catch (err) {
    console.error("Error checking block user", err);
    return false;
  }
};


  // Fetching dashboard Data
  const fetchData = async () => {
    setnloading(true);
    try {
      const data1 = await fetchDashboardData({
        MemberId: decryptData(localStorage.getItem("clientId") as string),
        UserToken: decryptData(localStorage.getItem("userToken") as string),
        CookieId: "",
        ActionMode: "DashboardLoadCounts",
      });
      // console.log(data);
      if (data1[0]?.StatusCode === "0") {
        showAlert("Your login is expired, Please relogin");
        localStorage.clear();
        navigate(`${import.meta.env.BASE_URL}/login`);
      }
      setallData(data1);

      setactOverview({
        FinalPayout: data1[0].FinalPayout,
        FinalBalance: data1[0].FinalBalance,
      });

      setmyWallets({
        BalanceInWallet: data1[0].BalanceInWallet,
        TotalWithdrawal: data1[0].TotalWithdrawal,
      });

      // setDashboardBox(data1[0]?.DashboardBox);
      setLastLogin(data1[0]?.LastLoginDate);
      setnloading(false);
    } catch (error) {
      console.error(error);
    } finally {
      setnloading(false); // ✅ hide skeleton after API done
    }
  };

  const FetchModal = async () => {
    setfxstModal(true);
  };

  useEffect(() => {
  const initDashboard = async () => {
    if (!refdash.current) {
      const isActive = await checkBlockUser();
      if (!isActive) return;
      await fetchData();
      refdash.current = true;
    }
  };
  initDashboard();
}, []);


  // useEffect(() => {
  //   if (!refdash.current) {
  //     fetchData();
  //     refdash.current = true;
  //   }
  // }, []);

  useEffect(() => {
    FetchModal();
    const timer = setTimeout(() => {
      document.body.style.paddingRight = "";
    }, 2000); // Delay of 2000ms (2 seconds)

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Breadcrumbs mainTitle={Dashboard} parent={DashboardPage} />
      {/* ✅ Dummy Popup Modal */}
      <Modal
        isOpen={showDummyModal}
        toggle={() => setShowDummyModal(false)}
        centered
      >
        <ModalBody className="text-center">
          <H2 className="mb-2">ख़ुशी है कि आप यहाँ हैं! 🎉</H2>
          <P className="mb-2">
            स्वागत है आपका सुकन्या स्वस्तिक केयर परिवार में!
          </P>
          <Btn color="primary" onClick={() => setShowDummyModal(false)}>
            Close
          </Btn>
        </ModalBody>
      </Modal>
      {!nloading ? (
        <Container fluid className="default-dashboard">
          <Row>
            <ProfileGreet pdata={allData[0]} />
            <AccountOverview
              incomeData={allData[0]}
              walletdata={myWallets}
            />
            <Notifications />
            {/* <Wallet walletdata={myWallets} />  */}

            {/* <TaskSummary dashboardBox={dashboardBox} /> */}
            <IncomeBoxes incomeData={allData[0]} />
            {/* <AchieversList />
            <Notifications /> */}
          </Row>
        </Container>
      ) : (
        <Container fluid className="default-dashboard">
          <DashboardSkeleton />
        </Container>
      )}
    </>
    // <>
    //   <Breadcrumbs mainTitle={Dashboard} parent={DashboardPage} />
    //   {!loading ? <Container fluid className="default-dashboard">
    //     <Row>
    //       <ProfileGreet profileName={profileName} loadingStatus={loading} />
    //       <AccountOverview actOverviewData={actOverview} LastLogin={LastLogin} />
    //       <Wallet walletdata={myWallets} />
    //       <TaskSummary dashboardBox={dashboardBox}/>
    //       <CoursesHighlighted LatestAnnouncement={latestAnnouncement}/>
    //       <Notifications />

    //     </Row>

    //     <Modal isOpen={modalOpen} toggle={closeModal} centered>
    //       <ModalHeader toggle={closeModal} className="mymodal-header px-4">
    //         Scan the QR code below to complete your payment quickly and securely!
    //       </ModalHeader>
    //       <ModalBody className="mymodal-body text-center" >
    //         <div style={{ height: 'auto', width: '100%' }}>
    //           <Image className="img-fluid" alt='popimage' src={`${import.meta.env.VITE_APP_POPUP_URL}/${popImageURL}`} />
    //         </div>
    //       </ModalBody>
    //     </Modal>
    //     <Modal isOpen={nextModalOpen} toggle={closeNextModal} centered>
    //       <ModalHeader toggle={closeNextModal} className="mymodal-header px-4">
    //         IMPORTANT NOTICE
    //       </ModalHeader>
    //       <ModalBody className="mymodal-body text-center" >
    //         <div style={{ height: 'auto', width: '100%' }}>
    //           <Image className="w-50" alt='popimage' title='popImage' src={dynamicImage("logo2.png")} />
    //           <div className='text-start'>
    //             <P className='py-4 text-danger p-4'>
    //               "Dear Fxstock Family Members,
    //               From November 1st, the user whose two direct IDs are not paid will not be able to withdraw their payout, and from November 1st, their payout will also stop generating."
    //             </P>
    //           </div>
    //           <div className='text-end'>
    //             <Btn color='primary' onClick={closeNextModal}>
    //               Close
    //             </Btn>
    //           </div>
    //         </div>
    //       </ModalBody>
    //     </Modal>
    //     <Modal isOpen={fxstModal} toggle={closeFXSTModal} centered>
    //       {/* <ModalHeader toggle={closeFXSTModal} className=" px-4 cardHeaderCustom">
    //         TRUST ME CE
    //       </ModalHeader> */}
    //         <ModalBody className="boxshadow text-center rounded" >
    //         <div style={{ height: 'auto', width: '100%' }}>
    //           <Image className="w-50" alt='popimage' title='popImage' src={dynamicImage("logo/tmc_logo_final.png")} />

    //           <div className='text-start'>
    //             <P className='py-4 text-info p-4'>
    //               <H1>HAPPY NEW YEAR, 2025</H1>
    //               ✨🚀Stepping into 2025, let's embrace innovation and seize new opportunities. Together, we'll transform visions into reality and set milestones for the future. 🚀
    //             </P>
    //           </div>
    //           <div className='text-end'>
    //             <Btn color='primary' onClick={closeFXSTModal}>
    //               Close
    //             </Btn>
    //           </div>
    //         </div>
    //       </ModalBody>
    //     </Modal>
    //   </Container>
    //     :
    //     <Container fluid className="default-dashboard">
    //       <DashboardSkeleton />
    //     </Container>
    //   }
    // </>
  );
};

export default ContainerDashboard;
